import React, { useContext, useEffect, useState } from 'react';
import { ArrowDownCircle } from 'react-bootstrap-icons';
import { Card, CardHeader, CardBody, Container, Row, Col, Button, Media } from 'reactstrap';
import SimpleHeader from '../../components/Headers/SimpleHeader';
import { Store } from '../../Store';
import client from '../../utils/client';

const Notifications = () => {
  const { state, dispatch } = useContext(Store);
  const { notifications } = state;

  const [openNotification, setOpenNotification] = useState(null);

  useEffect(() => {
    (async () => {
      const { data } = await client(`admin-gc/notifications`);
      if (data) {
        dispatch({ type: 'NOTIFICATIONS_FETCHED', payload: { ...data, unRead: 0 } });
        const notificationIds = data.notifications?.filter((n) => !n.read).map((n) => n.id);
        if (notificationIds) {
          await client(`admin-gc/notifications/read`, { body: { notificationIds } });
        }
      }
    })();
  }, []);

  return (
    <>
      <SimpleHeader name="Meddelande" parentName="" />
      <Container className="mt--6" fluid>
        <Row className="flex-column-reverse flex-lg-row">
          <Col>
            <Card>
              <CardHeader>
                <h5 className="h3 mb-0">Meddelande</h5>
              </CardHeader>
              <CardBody>
                {notifications?.data?.map((n) => (
                  <div className="mb-1" key={n.id}>
                    <Media className="media-comment" style={{ flex: 1 }}>
                      <div className="icon icon-shape bg-gradient-green text-white media-comment-avatar">
                        <i className="ni ni-chat-round" />
                      </div>

                      <Media style={{ flex: 1 }}>
                        <div className="media-comment-text" style={{ flex: 1 }}>
                          <div className="d-flex justify-content-between align-items-center">
                            <h6 className="h5 mt-0">{n.title}</h6>
                            <div className="text-right text-muted">
                              <small>{n.date}</small>
                            </div>
                          </div>
                          {!n.read || openNotification === n.id ? (
                            <p
                              className="text-sm lh-160"
                              // eslint-disable-next-line react/no-danger
                              dangerouslySetInnerHTML={{ __html: n.message }}
                            />
                          ) : (
                            <div className="ml-auto">
                              <Button
                                className="btn-icon"
                                color="primary"
                                size="sm"
                                onClick={() => setOpenNotification(n.id)}
                              >
                                <ArrowDownCircle style={{ fontSize: 14 }} />
                                <span>Läs mer</span>
                              </Button>
                            </div>
                          )}
                        </div>
                      </Media>
                    </Media>
                  </div>
                ))}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Notifications;
